import { render, staticRenderFns } from "./BotAccountFacebook.vue?vue&type=template&id=11c90082&scoped=true"
import script from "./BotAccountFacebook.vue?vue&type=script&lang=js"
export * from "./BotAccountFacebook.vue?vue&type=script&lang=js"
import style0 from "./BotAccountFacebook.vue?vue&type=style&index=0&id=11c90082&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "11c90082",
  null
  
)

export default component.exports